/**
 * The type of (redux) action which signals that local media duration has changed.
 *
 * {
 *     type: UPDATE_LOCAL_TRACKS_DURATION,
 *     localTracksDuration: Object
 * }
 */
export const UPDATE_LOCAL_TRACKS_DURATION = 'UPDATE_LOCAL_TRACKS_DURATION';
